import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { childPreferenceApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ChildPreferenceFormData } from '../types/child-preference';

export function useChildPreferences() {
  return useQuery({
    queryKey: queryKeys.childPreferences.list(),
    queryFn: () => childPreferenceApi.listPreferences(),
  });
}

export function useUpdateChildPreference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ChildPreferenceFormData }) =>
      childPreferenceApi.updatePreference(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.childPreferences.list() }),
  });
}
